<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="syringe flatbed icon"></i>
        <div class="content">
          New Purchased Invoice
        </div>
      </h2>
    </div>
    <br/>
    <div class="ui form" id="new-invoice-form">
      <h4 class="ui dividing header">
        Basic Infromation
      </h4>

      <div class="two fields">
        <div class="field">
          <label for="real_number">Invoice Number</label>
          <div class="ui input">
            <input type="text"
                   :placeholder="'Invoice Number'"
                   v-model="purchasedInvoice.real_number"
                   name="real_number">
          </div>
        </div>

        <div class="required field">
          <label for="purchasedDate">Purchased Date</label>
          <div style="text-align: center" class="ui calendar" :id="'purchased-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'Purchased Date'"
                     readonly=""
                     name="purchasedDate">
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label>Notes</label>
        <textarea
          rows="3"
          :placeholder="'Notes'"
          v-model="purchasedInvoice.notes"
          name="notes"
        />
      </div>

      <br/>

      <h4 class="ui dividing header">
        Company & Users Infromation
      </h4>

      <div class="required two fields">
        <div class="field">
          <label for="company">Company</label>
          <select
            name="company"
            class="ui fluid dropdown"
            id="company_select"
            v-model="companyIndex">
            <option value="">Company</option>
            <option :value="index" v-for="(company, index) in companies" :key="'company-' + index">
              {{ company.name }}
            </option>
          </select>
        </div>

        <div class="field" v-if="companyIndex != null && companyIndex > -1">
          <label for="branch">Branch</label>
          <select
            name="branch"
            class="ui fluid dropdown"
            :id="'branch_select'"
            v-model="purchasedInvoice.branch_id"
            :key="branchKey"
            >
            <option value="">Branch</option>
            <option :value="branch.id" v-for="(branch, index) in companies[companyIndex].branches" 
              :key="'branch-' + companyIndex + '-' + index">
              {{ branch.address }}
            </option>
          </select>
        </div>
      </div>

      <div class="field">
        <label for="companyEmployeeName">Company Employee Name</label>
        <div class="ui input">
          <input type="text"
                 :placeholder="'Company Employee Name'"
                 v-model="purchasedInvoice.company_employee_name"
                 name="companyEmployeeName">
        </div>
      </div>

      <div class="required field" style="width: 50%;">
        <label for="user">User Who Received</label>
        <select
          name="user"
          class="ui fluid dropdown"
          id="user_select"
          v-model="purchasedInvoice.user_who_receive_id">
          <option value="">User</option>
          <option :value="profile.user.id" v-for="(profile, index) in profiles" :key="index">
            {{ profile.role_type }} :
            {{ profile.user.name }}
          </option>
        </select>
      </div>

      <br/>

      <h4 class="ui dividing header">
        Items Information
      </h4>

      <invoiceEntry
        v-for="(invoiceEntry, index) in purchasedInvoice.invoice_entries"
        :items="items.items"
        :item="invoiceEntry"
        :identifier="invoiceEntry.identifier"
        @invoice-item-changed="setInvoiceEntry"
        :showError="showError"
        style="width: 100%"
        :key="'invoiceEntry-' + index"
      />

      <div class="ui blue right floated submit button"
           style="background-color: #092442"
           :class="{disabled: isPressed}"
           @click="save()">
        Submit
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    invoiceEntry:
      require('@/components/inventory_system/invoices/new_invoice_components/InvoiceEntry').default
  },
  data () {
    return {
      showError: false,
      loading: true,
      isPressed: false,
      companyIndex: null,
      branches: [],
      branchKey: 0,
      companies: [],
      profiles: [],
      items: [],
      invoiceEntriesNumber: 1,
      purchasedInvoice: {
        real_number: '',
        date: '',
        notes: '',
        company_employee_name: '',
        branch_id: null,
        user_who_receive_id: null,
        invoice_entries: []
      }
    }
  },
  watch: {
    companyIndex: {
      handler: function () {
        $('#branch_select').dropdown('clear')
        $('#branch_select').dropdown('refresh')
        $('#branch_select').dropdown('set selected', this.companies[this.companyIndex].branches[0].id)

        this.initGUI()
      },
      deep: true
    }
  },
  mounted () {
    this.axios.all([this.getCompanies(), this.getEmployees(), this.getDoctors(), this.getItems()])
      .then(this.axios.spread(
        (companiesResponse, employeesResponse, doctorsResponse, itemsResponse) => {
          this.companies = companiesResponse.data

          employeesResponse.data = window._.map(employeesResponse.data, profile => ({
            ...profile,
            role_type: 'Employee'
          }))

          doctorsResponse.data = window._.map(doctorsResponse.data, profile => ({
            ...profile,
            role_type: 'Doctor'
          }))

          this.profiles = window._.concat(employeesResponse.data, doctorsResponse.data)
          this.items = itemsResponse.data

          this.addInoviceEntry('defaultInvoiceEntry')
          this.loading = false
          this.initGUI()
        }
      ))
  },
  methods: {
    getCompanies () {
      return this.$http.get('companies')
    },
    getEmployees () {
      return this.$http.get('employees', {
        params: {
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      })
    },
    getDoctors () {
      return this.$http.get('doctors')
    },
    getItems () {
      return this.$http.get('items', {
        params: {
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      })
    },
    initGUI () {
      this.$nextTick(() => {
        $('#company_select').dropdown()
        $('#branch_select').dropdown()
        $('#user_select').dropdown()

        $('#purchased-date').calendar({
          type: 'datetime',
          maxDate: new Date(),
          onChange: (date) => {
            this.purchasedInvoice.date = date
          }
        })

        $('#new-invoice-form').form({
          inline: true,
          on: 'submit',
          onFailure: () => {
            this.showError = !this.showError
          },
          fields: {
            purchasedDate: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Choose the purchased date.'
                }
              ]
            },
            company: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Choose the Company you by the item from if it don\'t exist create it first.'
                }
              ]
            },
            branch: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Choose the branch you by the item from.'
                }
              ]
            },
            user: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Choose the user who receive it.'
                }
              ]
            }
          }
        })
      })
    },
    removeInvoiceEntry (id) {
      this.purchasedInvoice.invoice_entries =
        window._.filter(this.purchasedInvoice.invoice_entries, invoiceEntry => {
          return invoiceEntry.identifier !== id
        })
    },
    updateInvoiceEntry (updatedInvoiceEntry) {
      window._.each(this.purchasedInvoice.invoice_entries, invoiceEntry => {
        if (invoiceEntry.identifier === updatedInvoiceEntry.identifier) {
          invoiceEntry = updatedInvoiceEntry
        }
      })
    },
    remainingItems () {
      let selectedItemIds = window._.map(this.purchasedInvoice.invoice_entries, 'item_id')
      return window._.filter(this.items.items, item => {
        return !window._.includes(selectedItemIds, item.id)
      })
    },
    addInoviceEntry (id = null) {
      let identifier = id
      if (!identifier) identifier = (++this.invoiceEntriesNumber).toString()
      if (this.remainingItems().length > 0) {
        let invoiceEntry = this.invoiceEntryObject(identifier)
        this.purchasedInvoice.invoice_entries.push(invoiceEntry)
      }
    },
    setInvoiceEntry (event) {
      if (event.data.valid) {
        this.updateInvoiceEntry(event.data.item)

        if (this.validateLastInvoiceEntry()) {
          this.addInoviceEntry()
        }

        this.$forceUpdate()
      }
    },
    invoiceEntryObject (identifier) {
      return {
        identifier: identifier,
        item_id: null,
        quantity: null,
        unit_price: null,
        label: null,
        expired_at: null,
        remainingItems: this.remainingItems()
      }
    },
    validateLastInvoiceEntry () {
      let lastInvoiceEntry =
        this.purchasedInvoice.invoice_entries[this.purchasedInvoice.invoice_entries.length - 1]
      return this.checkValidInvoiceEntry(lastInvoiceEntry)
    },
    checkValidInvoiceEntry (invoiceEntry) {
      return invoiceEntry.item_id && invoiceEntry.quantity && invoiceEntry.unit_price
    },
    getInvoiceEntries () {
      return window._.filter(this.purchasedInvoice.invoice_entries, invoiceEntry => {
        return this.checkValidInvoiceEntry(invoiceEntry)
      })
    },
    save () {
      let invoiceEntries = this.getInvoiceEntries()
      if (invoiceEntries.length > 0) {
        let sendData = {
          ...this.purchasedInvoice,
          invoice_entries: invoiceEntries
        }
        this.isPressed = true
        this.$http.post('invoices/purchase', {
          clinic_id: this.getFromLocalStorage('clinicId'),
          invoice: sendData
        }).then(response => {
          this.navigateTo('Show_Invoice', { key: 'params', value: { id: response.data.id } })
        }).catch(() => {
          this.isPressed = true
        })
      }
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
  .virtical-center {
    display: flex !important;
    align-items: center !important;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventory_system/invoices/NewPurchasedInvoice.vue